/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {CreativeLinkLibraryModalComponent, CreativeLinkLibraryModalResult} from './creative-link-library-modal.component';

export interface CreativeLinkLibraryModalOptions {
  model: any;
  modelComms?: any;
  onComplete?: (result: CreativeLinkLibraryModalResult) => void;
}

@Injectable({providedIn: 'root'})
export class CreativeLinkLibraryModalService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  open(options: CreativeLinkLibraryModalOptions): void {
    this.angularModalService.show(CreativeLinkLibraryModalComponent, {
      initialState: options
    });
  }
}
